import BulkOps from "./BulkOps";

export default BulkOps;
